<div class="property-characteristic-page ws-flex-container-vertical ws-flex-auto">
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">
                Property Characteristics
                <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions"></ag-grid-row-count>
            </h4>
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <label class="me-2" for="category">Category:</label>
                    <ws-select
                        id="category"
                        data-qa="property-characteristics-category-select"
                        (ngModelChange)="getDescriptors($event)"
                        [ngModel]="selectedCategoryId"
                        [options]="categories"
                        [disabled]="dataLoading"
                        labelProperty="name"
                        valueProperty="descriptorCategoryID"
                    >
                    </ws-select>
                </div>
                <div class="ws-section__header__actions__item">
                    <button
                        type="button"
                        data-qa="property-characteristic-add-characteristic"
                        class="ace-btn btn-sm btn-primary"
                        (click)="addDescriptor()"
                        [disabled]="dataLoading || !canEdit"
                    >
                        Add Characteristic
                    </button>
                </div>
            </div>
        </div>
    </div>

    @if (initialized) {
        <ws-ag-grid-angular
            data-qa="property-characteristics-grid"
            [gridOptions]="gridOptions"
            (gridReady)="onAgGridReady($event)"
            [gridId]="gridId"
        >
        </ws-ag-grid-angular>
    }
</div>
